module.exports = __webpack_public_path__ + "images/emoji/sandal.c5982bd653a50ccbb478.png";